import { Pipe, PipeTransform } from "@angular/core"

@Pipe({
    name: "loadScrips",
})
export class LoadScriptsPipe implements PipeTransform {
    constructor() {}

    transform(value: string, parentElementId: string) {
        if (!value) {
            return
        }
        let jsUrls = value.match(/(\/\/.+\..+\/.+\.js)/g)

        if (jsUrls && jsUrls.length) {
            for (let url of jsUrls) {
                this.loadJsUrl(url, parentElementId)
            }
        }
        return value
    }

    loadJsUrl(url: string, parentElementId: string) {
        let parentElement = document.getElementById(parentElementId)
        let canJsLoad = function (url: string) {
            if (!url) return false
            let scripts = parentElement.getElementsByTagName("script")
            for (let i = scripts.length; i--; ) {
                if (scripts[i].src === url) return false
            }
            return true
        }
        // Load js url
        let insertJsUrl = function (url: string) {
            let script = document.createElement("script")
            script.setAttribute("src", url)
            parentElement.appendChild(script)
        }
        if (canJsLoad(url)) {
            insertJsUrl(url)
        }
    }
}
